export const locale = {
    lang: 'en',
    data: {
        MENU: {
            DASHBOARD: 'Dashboard',
            LEAD: 'Lead',
            BLOG: 'Blog',
            BLOG_POSTS: 'Posts',
            BLOG_CATEGORIES: 'Categories',
            BLOG_TAGS: 'Tags',
        }
    }
};
